module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_8017.67324f52.png";